export const TAKEN = 1; //Принят водителем
export const AT_LOADING = 2; //На погрузке
export const ON_DISPATCH = 3; //В пути
export const REST_PARKING = 4; //На отдыхе
export const ARRIVED = 5; //Прибыл
export const ON_UNLOADING = 6; //На разгрузке
export const FINISHED = 7; //Завершён
